import * as Yup from "yup";

export const dataModel = {
  courseUuid: "",
  month: "",
  centers: [],
  year: "",
};

export const validationDataModel = (edit) => {
  if (edit) {
    return Yup.object().shape({
      courseUuid: Yup.string().optional(),
      month: Yup.string().optional(),
      year: Yup.string().optional(),
    });
  } else {
    return Yup.object().shape({
      courseUuid: Yup.string().required("forms.validations.required"),
      month: Yup.string().required("forms.validations.required"),
      centers: Yup.array().required("forms.validations.required"),
      year: Yup.number().required("forms.validations.required"),
    });
  }
};

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
